import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './container/AuthProvider';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import 'react-smartbanner/dist/main.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);



root.render(
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider />
      </BrowserRouter>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
